import React from "react";

import { useGetDashboards } from "api/api-hooks/dashboards-hooks";
import { PermissionGuard } from "components/wrappers/PermissionGuard";
import { Card } from "primereact/card";
import { T } from "services/lang/LanguageService";
import "../dashboard-management-styles.scss";
import DashboardManagementTable from "./DashboardManagementTable";

const DashboardManagement: React.FC = () => {
  const { data, isLoading } = useGetDashboards();

  return (
    <PermissionGuard permissions="CUSTOMIZE_DATA_SERVICE_DASHBOARD">
      <Card
        title={T("title.dashboards-management")}
        style={{ minHeight: "80vh" }}
        className="dashboard-management-wrapper"
      >
        <DashboardManagementTable dashboards={data ?? []} isLoading={isLoading} />
      </Card>
    </PermissionGuard>
  );
};

export default DashboardManagement;
